import { stdObject } from "./types/stdObject";

export const docFieldsCodes = [
  "NOM",
  "SUC",
  "RSO",
  "RUC",
  "AGE",
  "INT",
  "PRE",
  "SDA",
  "ART",
  "ARTSE0",
  "NOMSE0",
  "CANSE0",
  "PRESE0",
  "TOTSE0",
  "NET",
  "IMP",
  "TOT",
];

export const docItemCodes = ["ARTSE0", "NOMSE0", "CANSE0", "PRESE0", "TOTSE0"];

export const docCodes: stdObject = Object.freeze({
  A1: "PED",
  A2: "ENT",
  A3: "CFA",
  A4: "DEV",
  A5: "SAL",
  A6: "TRA",
  A7: "Receive Transfers",
  B1: "COT",
  B2: "ORD",
  B3: "CAJ",
  B4: "PRE",
  B5: "FAC",
  B6: "REG",
  B7: "ALC",
  C1: "SEV",
  C2: "SEV",
  C3: "SEV",
  F2: "ART",
  ART: "ART",
  CLI: "CLI",
  PRO: "PRO",
});

export const docIdCodes: stdObject = Object.freeze({
  PED: "A1",
  ENT: "A2",
  CFA: "A3",
  DEV: "A4",
  SAL: "A5",
  TRA: "A6",
  TRA2: "A7",
  COT: "B1",
  ORD: "B2",
  CAJ: "B3",
  PRE: "B4",
  FAC: "B5",
  REG: "B6",
  ALC: "B7",
  SEV: "C1",
});

export const transferDocs = {
  PED: ["ENT", "CFA"],
  ENT: ["CFA"],
  COT: ["ORD", "PRE", "FAC"],
  ORD: ["PRE", "FAC"],
  PRE: ["FAC", "REG"],
  FAC: ["REG"],
  SEV: ["REG"],
};

export const docCustomersCodes = ["CLI", "RES"];

export const inputTimeBack = 300;
